import { render, staticRenderFns } from "./ProductInfos.vue?vue&type=template&id=7992b446&scoped=true&"
import script from "./ProductInfos.vue?vue&type=script&lang=js&"
export * from "./ProductInfos.vue?vue&type=script&lang=js&"
import style0 from "./ProductInfos.vue?vue&type=style&index=0&id=7992b446&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7992b446",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseCollapse: require('/opt/build/repo/components/BaseCollapse.vue').default,IMinusSign: require('/opt/build/repo/components/svg/MinusSign.vue').default,ICartAdd: require('/opt/build/repo/components/svg/CartAdd.vue').default})
